import { call, put, takeLatest } from 'redux-saga/effects';
import { httpRequestsOnLoadActions } from '../../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../../http_requests_on_success';
import { httpRequestsOnErrorsActions } from '../../http_requests_on_errors';
import {
    CREATE_EVENT,
    DELETE_EVENT,
    EDIT_EVENT,
    GET_EVENT_GRAPH,
    GET_EVENT_GRAPH_SUCCESS,
    GET_EVENTS,
    GET_EVENTS_GRAPH_DATA,
    GET_EVENTS_GRAPH_DATA_SUCCESS,
    GET_EVENTS_SUCCESS,
} from './event.types';
import { authService } from './event.service';

/** Events */

function* getEvents({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    try {
        const res = yield call(authService.getEventsService, payload?.resourceId, payload?.params);
        yield put({
            type: GET_EVENTS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* getEventsGraphData({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    try {
        const res = yield call(authService.getEventsGraphDataService, payload?.params);
        yield put({
            type: GET_EVENTS_GRAPH_DATA_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* createEvent({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.createEventService, payload?.body);
        // const res = yield call(authService.getEventsService, payload?.params);
        // yield put({
        //     type: GET_EVENTS_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* editEvent({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.editEventService, payload?.id, payload?.body);
        // const res = yield call(authService.getEventsService, payload?.params);
        // yield put({
        //     type: GET_EVENTS_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnErrorsActions.removeError(type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* deleteEvent({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        yield call(authService.deleteEventService, payload?.id);
        // const res = yield call(authService.getEventsService, payload?.params);
        // yield put({
        //     type: GET_EVENTS_SUCCESS,
        //     payload: res.data,
        // });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

function* getEventGraph({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.getEventGraphService, payload?.params);
        yield put({
            type: GET_EVENT_GRAPH_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
        yield put(httpRequestsOnErrorsActions.appendError(type));
    }
}

/** End */

export const watchEvents = function* watchEventsAuth() {
    /** Events  */
    yield takeLatest(GET_EVENTS, getEvents);
    yield takeLatest(GET_EVENTS_GRAPH_DATA, getEventsGraphData);
    yield takeLatest(CREATE_EVENT, createEvent);
    yield takeLatest(EDIT_EVENT, editEvent);
    yield takeLatest(DELETE_EVENT, deleteEvent);
    yield takeLatest(GET_EVENT_GRAPH, getEventGraph);
    /** End */
};
